export default __webpack_public_path__ + "98a5c4c60446f1ab52e536a8b5f4ca9b.pdf";